 export const sliderData = [
    {
        info: "Football Enthusiast"
    },
    {
        info: "Community Oriented"
    },
    {
        info: "Success Drivin"
    },
    {
        info: "Avid Gamer"
    }
]